export { LpOwnProductsHeaderComponent } from './header/lp-own-products-header.component';
